module.exports = __webpack_public_path__ + "static/img/ex_t2.32283eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_t2.jpg
// module id = IAtn
// module chunks = 1